import { Router } from "@frui.ts/screens";
import { bound } from "@frui.ts/helpers/dist";
import { Modules } from "config";
import TransferType from "entities/transferType";
import RefundType from "entities/refundType";
import EventBus, { SEPATransferRefundUpdated } from "services/eventBus";
import LocalizationService from "services/localizationService";
import OptionsService from "services/optionsService";
import RefundForRefundOfRefundsRepository from "repositories/refundForRefundOfRefundsRepository";
import type CountrySelectViewModel from "../../../../countrySelectViewModel";
import TransferRefundForRefundOfRefundsViewModel from "../transferRefundForRefundOfRefundsViewModel";
import SEPARefundForRefundOfRefundsDetailViewModel from "./SEPARefundForRefundOfRefundsDetailViewModel";
import RefundsApprovalService from "services/refundsApprovalService";

const navigationName = "SEPA";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [SEPARefundForRefundOfRefundsDetailViewModel],
})
export default class SEPARefundForRefundOfRefundsViewModel extends TransferRefundForRefundOfRefundsViewModel {
  readonly transferType = TransferType.Sepa;
  readonly refundType = RefundType.SepaTransfer;

  constructor(
    protected detailViewModelFactory: ReturnType<typeof SEPARefundForRefundOfRefundsDetailViewModel.Factory>,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected approvalService: RefundsApprovalService,
    protected optionsService: OptionsService,
    protected repository: RefundForRefundOfRefundsRepository,
    protected countrySelectViewModelFactory: ReturnType<typeof CountrySelectViewModel.Factory>
  ) {
    super(
      detailViewModelFactory,
      localizationService,
      eventBus,
      approvalService,
      optionsService,
      repository,
      countrySelectViewModelFactory
    );
    this.navigationName = navigationName;
  }

  onInitialize() {
    this.unsubscriptions.push(this.eventBus.subscribe(SEPATransferRefundUpdated, this.loadData));
    return super.onInitialize();
  }

  @bound
  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `refundForRefundOfRefunds.SEPA.${code}`, size);
  }
}
